import Vue from "vue";
import { deepCopy, getFlowXYPosition } from "@/utils";
import { componentList } from "@/components/components";
import { SaveStep } from "@/api/flow.api";
var d3 = require("d3");
/**
 * @type {
 * systemComponents: 系统组件
 *  viewEditArea,
 * flowData: {
 * selectComponent: string,
 * currentXY: {top: number, left: number},
 * source: {sourceNodeId: string, sourcePortId: string, cat: string, key: string},
 * target: {model: boolean, targetNodeId: string, targetPortId: string},
 * nodes: Array, currentNodeItem: {},
 * currentNodeId: {curNodeId: string, curNodeIndex: string},
 * addMenuItem: string,
 * },
 */
const state = {
  systemComponents: {
    ...componentList,
    // {
    //   id: 0,
    //   name: "系统组件",
    //   enabled: true,
    //   component: false,
    //   children: [...componentList]
    // }
  },
  // 系统组件菜单
  viewEditArea: {
    // 查看结果
    previewResultDialog: false, // 查看结果展示框
    previewResultData: [], // 结果信息
    previewResultMessage: "",
  }, // 编辑区交互信息
  flowData: {
    // 流程数据对象
    nodeRightContentMsg: {
      left: 300,
      top: 200,
      display: "none",
    }, // 流程中节点右键菜单信息
    isStop: false,
    isRunning: false, // 当前流程是否在运行
    runningTotal: 0, // 需要运行的数量
    runningCount: 0, // 已运行的数量
    currentProjectDetail: {}, // 当前操作工程的基本信息
    landingInfo: {
      isLoading: true,
      index: -1,
      info: { label: "输入源", labels: [], text: "" },
      data: [],
      allLabelsId: [],
      isEnd: false,
    },
    nodes: [],
    links: [],
    // nodes: [],
    // links: [],
    currentXY: {
      left: 0,
      top: 0,
    }, // 当前选中节点左上角坐标

    isNodeDrag: false,
    dragNode: {},
    isLinkDrag: false,
    dragLink: {},

    currentNodeItem: {}, // 当前点击节点项
    currentNodeId: {
      // 当前节点
      curNodeId: "",
      curNodeIndex: "",
    }, // 当前选中节点信息
    currentPath: {
      // 当前选中连线
      curPathId: "",
      curPathIndex: "",
    }, // 当前选中连线信息
    ifAddDom: false, // 是否为添加节点
    addMenuItem: "", // 从菜单栏添加的菜单项源
    isConnecting: false, // 线条指向的点是否可以被连接
    pointLayer: {
      x: 0,
      y: 0,
    }, // 鼠标相对于节点偏移位置信息
    target: {
      targetNodeId: "",
      targetPortId: "",
      model: false, // 是否可接入模型
    }, // 箭头指向的节点id及连接点id
    source: {
      sourceNodeId: "",
      sourcePortId: "",
      key: "", // 通过key判断输出是否为模型
      cat: "", // 类型DATA\MODEL\UNSTRACT
    }, // 箭头按下的节点啊id及连接点id
    selectComponent: "", // 根据设置值用来切换右侧视图 目前值：project_props、project_content_msg
    nodeChange: true, // 必须，用来切换销毁重绘右侧组件
    positionChange: false, // 必须，进行位移校验，判断是否修改坐标
  },
};

// getters
const getters = {};

// actions
const actions = {
  closeLandingLoading ({ state }) {
    state.flowData.landingInfo.isLoading = false;
  },
  // 设置案例信息和流程json
  setProjectDetail ({ state, dispatch }, payload) {
    const { projectInfo = {}, isAdd, nodes, links } = payload;
    state.flowData.currentProjectDetail = { ...projectInfo, isAdd };
    state.flowData.nodes = nodes || [];
    state.flowData.links = links || [];
    // 引导页
    if (projectInfo.landingData && projectInfo.landingData.length > 0) {
      const landingInfo = state.flowData.landingInfo;
      landingInfo.isLoading = true;
      landingInfo.index = -1;
      landingInfo.data = projectInfo.landingData || [];
      dispatch("nextProjectLandingData");
      dispatch(
        "updateNodeView",
        landingInfo.info.labels[landingInfo.info.labels.length - 1]
      );
    } else {
      state.flowData.landingInfo.isLoading = false;
    }
  },
  setProjectLandingData ({ state, dispatch }) {
    const landingInfo = state.flowData.landingInfo;
    landingInfo.info = landingInfo.data[landingInfo.index];
    landingInfo.isEnd = landingInfo.index === landingInfo.data.length - 1;
  },
  // 设置案例引导数据，下一步
  nextProjectLandingData ({ state, dispatch }) {
    const landingInfo = state.flowData.landingInfo;
    if (landingInfo.index < landingInfo.data.length - 1) {
      landingInfo.index++;
      // 累加下一步的id
      dispatch("setProjectLandingData");
      landingInfo.allLabelsId = landingInfo.allLabelsId.concat(
        landingInfo.info.labels
      );
    }
  },
  // 设置案例引导数据，上一步
  preProjectLandingData ({ state, dispatch }) {
    const landingInfo = state.flowData.landingInfo;
    if (landingInfo.index > 0) {
      const infoDataLabels = [...landingInfo.data[landingInfo.index].labels];
      landingInfo.index--;
      // 从所有id中删除上一步的id
      dispatch("setProjectLandingData");
      landingInfo.allLabelsId = landingInfo.allLabelsId.filter(
        (id) => !infoDataLabels.includes(id)
      );
    }
  },
  // 手动更新节点的视图
  updateNodeView ({ state, commit }, id) {
    const { nodes } = state.flowData;
    state.flowData.currentNodeItem = nodes.find((item) => item.id === id);
    commit("updateMenuProjectSelectComponent", "");
    setTimeout(() => {
      commit("updateMenuProjectSelectComponent", "PropsDestroy"); // 更新右侧组件视图
    }, 100);
    commit("updateMenuProjectNodeChange"); // 更新组件切换状态
  },
  // 设置案例引导数据，跳过引导
  stopProjectLandingData ({ state }) {
    state.flowData.landingInfo.isLoading = false;
    state.flowData.landingInfo.allLabelsId = [];
  },
  // 设置流程json
  setProjectFlow ({ state }, payload) {
    const { nodes, links } = payload;
    state.flowData.nodes = nodes || [];
    state.flowData.links = links || [];
  },
  // 添加节点
  addFlowNodeItem ({ state, rootState, commit, dispatch }, target) {
    // try {
    state.flowData.positionChange = true;
    const positions = getFlowXYPosition(target, state.flowData.pointLayer); // 获取被拖拽节点的左上角原点坐标
    state.flowData.currentXY = positions; // 更新拖拽移动后的节点的原点坐标

    // 添加节点
    if (state.flowData.ifAddDom) {
      const compId = Date.now();
      var componentItem = state.flowData.addMenuItem; // 添加组件项
      var inputs = []; // 输入点集合
      var inputData = []; // 输入集
      var outputData = []; // 输出集
      if (componentItem.inputs) {
        var inNum = componentItem.inputs.length; // 输入点数量
        var inEveryLeft = 180 / (inNum + 1);
        for (var i = 1; i <= inNum; i++) {
          inputs.push({
            id: compId + "_1_" + i,
            isConnected: false,
            left: inEveryLeft * i,
            description: componentItem.inputs[i - 1].description,
            ...componentItem.inputs[i - 1],
          });
        }
      }
      var outputs = []; // 输出点集合
      if (componentItem.outputs) {
        var outNum = componentItem.outputs.length;
        var outEveryLeft = 180 / (outNum + 1);
        for (var i = 1; i <= outNum; i++) {
          var value = "";
          if (componentItem.outputs[i - 1].value) {
            // 当添加为模型时，value值为模型路径
            value = componentItem.outputs[i - 1].value;
          } else {
            value = compId + "_0_" + i;
          }
          outputs.push({
            id: compId + "_0_" + i,
            left: outEveryLeft * i,
            description: componentItem.outputs[i - 1].description,
            ...componentItem.outputs[i - 1],
          });
        }
      }
      const nodeId = compId + ""; // 节点id
      const nodeItem = {
        // 节点信息
        id: nodeId, // 节点id
        // serverId: componentItem.id,//组件服务端ID
        // engine: componentItem.extra.engine,
        name: componentItem.name, // 节点名称
        methodNum: componentItem.methodNum,
        isResource: componentItem.isResource || false,
        resourceId: componentItem.resourceId,
        // hasReport: false,
        // iconPath:'fa-cubes', //componentItem.iconPath ? (componentItem.iconPath.length > 0 ? componentItem.iconPath : "fa-cubes") : "fa-cubes",
        runStyle: "status-disW", // 运行背景色 默认status-disW  完成 status-sus 失败 status-erro
        description: componentItem.description, // 组件描述
        left: state.flowData.currentXY.left,
        top: state.flowData.currentXY.top,
        inputs,
        outputs,
        tabs: [...componentItem.tabs],
        inputData, // 节点的输入数据集，可能存在多个
        outputData, // 节点的输出数据集，结构与输入保持一致
        // outputExtraData: [],//当前节点的额外输出字段
        lastUpdateTime: new Date().getTime(), // 添加日期时间戳
      };
      const ifExist = state.flowData.nodes.filter(
        (node) => node.id == nodeItem.id
      );
      if (ifExist.length > 0) {
        this.$notify({
          type: "warning",
          message: "组件ID重复，添加失败！",
        });
      } else {
        state.flowData.nodes.push(deepCopy(nodeItem)); // 添加节点
      }

      state.flowData.isNodeDrag = false;
      state.flowData.ifAddDom = false;
    }
    // } catch (e) {
    //   console.error(e.message);
    // }
  },
  /**
   * 流程执行完成
   */
  setFlowComplete ({ state, rootState }) {
    state.flowData.isRunning = false;
    state.flowData.links.forEach(function (item) {
      item.runStyle = "";
    });
    rootState.global.exceptionDeal.flowRunningComplete = true;
    Vue.$requestList = [];
  },
  // 运行流程（根据开始节点运行）
  async runAllFlow ({ state, dispatch }, payload) {
    const { nodes, links } = state.flowData;
    dispatch("runFlow", {
      nodes,
      links,
    });
  },
  setFlowError ({ rootState }) {
    rootState.global.exceptionDeal.flowRunningSuccess = false
  },
  // 运行节点的流程链路（根据当前节点运行）
  async runNodeFlow ({ state, dispatch }, payload) {
    const { nodes, links } = state.flowData;
    const nodeItemId = state.flowData.currentNodeItem.id;

    // 找出当前节点之前的流程链路
    const bindBeforeFlowByStartId = (id) => {
      const list = links.filter((item) => item.target === id);
      if (list.length > 0) {
        let ids = [id];
        for (const item of list) {
          ids = ids.concat(bindBeforeFlowByStartId(item.source));
        }
        return ids;
      } else return [id];
    };
    const ids = Array.from(
      new Set(bindBeforeFlowByStartId(nodeItemId).reverse())
    );

    dispatch("runFlow", {
      nodes: nodes.filter((item) => ids.includes(item.id)),
      links: links.filter(
        (item) => ids.includes(item.target) && ids.includes(item.source)
      ),
    });
  },
  async runFlow ({ state, commit, dispatch }, payload) {
    const { nodes, links } = payload;
    // 运行前将流程恢复默认状态
    commit("backFlowToDefault");
    state.flowData.isStop = false;
    state.flowData.isRunning = true;
    state.flowData.runningCount = 0;

    state.flowData.runningTotal = nodes.length;

    // 找出流程中所有的第一个节点，包含单节点，首节点
    const beginNodeList = [];
    // 单节点
    for (const node of nodes) {
      const obj = links.find(
        (item) => node.id === item.target || node.id === item.source
      );
      if (!obj) beginNodeList.push(node.id);
    }
    // 首节点
    let startIds = [];
    for (const link of links) {
      const obj = links.find((item) => link.source === item.target);
      if (!obj) startIds.push(link.source);
    }
    // 去重
    startIds = Array.from(new Set(startIds));
    const nodeIds = beginNodeList.concat(startIds);
    for (const nodeId of nodeIds) {
      dispatch("runningNodeById", {
        nodeId,
        nodes,
        links,
      });
    }
  },
  /**
   * 运行节点
   * @param {*} param0
   * @param {*} param1
   */
  runningNodeById (
    { state, rootState, dispatch },
    { nodeId, link, nodes, links }
  ) {
    // 节点
    const nodeItem = nodes.find((item) => item.id === nodeId);
    if (link) {
      let list = links.filter(({ target }) => target === nodeId);
      if (list.length > 1) {
        nodeItem.runStyle = "status-await";
        list = list.filter((item) => !item.isRunning);
        if (list.length > 0) return;
      }
    }
    const runningNodeData = {
      nodes,
      links,
      nodeItem,
      back: (success) => {
        // console.log('--节点运行结束----', nodeId)
        const list = links.filter((item) => item.target === nodeItem.id);
        for (const link of list) {
          link.runStyle = ""; // 改连线状态
          delete link.isRunning;
        }
        state.flowData.runningCount++;
        if (success) {
          if (state.flowData.runningCount === state.flowData.runningTotal) {
            dispatch("setFlowComplete");
          } else {
            // 根据当前节点找下一节点执行
            setTimeout(() => {
              if (state.flowData.isStop) {
                return;
              }
              const list = links.filter(({ source }) => source === nodeItem.id);
              list.forEach((item) => {
                item.isRunning = true;
                item.runStyle = "pane-link-flow";
                dispatch("runningNodeById", {
                  nodeId: item.target,
                  link: item,
                  nodes,
                  links
                });
              });
            }, 300);
          }
        } else {
          // 根据当前节点找后面所有节点
          const fun = (id) => {
            const list = links.filter((link) => link.source === id);
            if (list.length > 0) {
              let ids = [];
              for (const { target } of list) {
                ids.push(target);
                ids = ids.concat(fun(target));
              }
              return ids;
            } else {
              return [];
            }
          };
          const ids = Array.from(new Set(fun(nodeId)));
          state.flowData.runningCount += ids.length;
          if (state.flowData.runningCount === state.flowData.runningTotal) {
            state.flowData.isRunning = false;
            if (!rootState.global.exceptionDeal.otherException) {
              dispatch("setFlowComplete");
            }
          }
          dispatch('setFlowError')
        }
      },
    };
    if (nodeItem.isResource) {
      //  输入节点获取数据源（数据源编辑功能开启和新增案例）
      if (window.editResource && state.flowData.currentProjectDetail.isAdd) {
        // 直接更改状态后返回
        setTimeout(() => {
          nodeItem.runStyle = "status-sus";
          runningNodeData.back(true);
        }, 100);
      } else {
        dispatch("runningResouceNode", runningNodeData);
      }
    } else {
      // 调用接口
      dispatch("runningNode", runningNodeData);
    }
  },
  /**
   * 调用节点的接口
   * @param {*} param0
   * @param {*} param1
   */
  runningNode ({ state }, { nodes, links, nodeItem, back }) {
    // 流程信息
    const projectDetail = state.flowData.currentProjectDetail;
    const { methodNum, tabs = [] } = nodeItem;
    const params = {
      jobid: projectDetail.id,
      pathNo: methodNum,
      inputParams: {},
      inputs: [],//{ inputs_file_path: "", data_index: "", data_key: "", file_type: "json_file" }
    }
    // 节点
    let linkList = links.filter(({ target }) => target === nodeItem.id);
    let arr = []
    for (let _link of linkList) {
      // 上一个节点
      let nodeObj = nodes.find(n => n.id === _link.source)
      let outputPortId = _link.outputPortId
      let obj = {
        inputs_file_path: nodeObj.outputData.result_file_path,
        data_index: "", data_key: "",
        file_type: "json_file"
      }
      // console.log(nodeItem.id, _link)
      if (nodeObj.isResource) {

      } else {
        let outputObj = nodeObj.outputs.find(item => item.id === outputPortId)
        obj.data_index = outputObj.outIndex
        obj.data_key = outputPortId.replace('output_data_dict2', 'output_data_dict')
      }
      let model_name = nodeObj.outputData.model_name
      if (model_name) {
        obj.file_type = 'model_file'
        obj.inputs_file_path = model_name;
      }
      arr.push(obj)
    }
    params.inputs = arr

    // 绑定inputParams
    const inputParams = {};
    if (tabs.length > 0) {
      for (const { elements = [] } of tabs) {
        for (const { name, values } of elements) {
          inputParams[name] = values;
        }
      }
      params.inputParams = inputParams;
    }
    // 设置运行状态
    nodeItem.runStyle = "status-working";
    SaveStep(params)
      .then((res) => {
        if (res.status === "200" || res.status === 200) {
          nodeItem.runStyle = "status-sus";
          nodeItem.outputData = {
            result_file_path: res.result_file_path,
            model_name: res.model_name,
          }
          if (back) back(true);
        } else {
          nodeItem.runStyle = "status-erro";
          nodeItem.outputMessage = res.message;
          if (back) back();
        }
      })
      .catch((res) => {
        nodeItem.runStyle = "status-erro";
        if (back) back();
      });
  },
  /**
   * 运行数据源节点
   * @param {*} param0
   * @param {*} param1
   */
  runningResouceNode ({ rootState }, { nodeItem, back }) {
    if (nodeItem.resourceId) {
      // 设置运行成功状态
      nodeItem.runStyle = "status-sus";
      if (nodeItem.resourceId) {
        nodeItem.outPutFile = nodeItem.resourceId + '.json'
        bindResourceData(nodeItem, nodeItem.resourceId + '.json');
      }
      back(true);
    } else {
      rootState.global.exceptionDeal.otherException = true;
      rootState.global.exceptionDeal.exceptionMessage = "请选择数据源";
      nodeItem.runStyle = "status-erro";
      if (back) back();
    }
  },
  // 停止流程
  stopFlow: function ({ state }) {
    state.flowData.isStop = true;
    state.flowData.isRunning = false;
    state.flowData.links.forEach(function (item) {
      item.runStyle = "";
    });
  },
  // 删除选中节点及连线
  deleteFlowNode ({ state, commit, dispatch }) {
    if (state.flowData.currentNodeId.curNodeId != "") {
      var arrs = []; // 创建临时变量用来存储节点相关线的id，
      state.flowData.links.forEach(function (element) {
        // 满足条件的pathId添加到临时数组中
        if (
          element.source == state.flowData.currentNodeId.curNodeId ||
          element.target == state.flowData.currentNodeId.curNodeId
        ) {
          arrs = arrs.concat(element.id);
        }
      });
      // 这里不直接遍历store.links的原因是：
      // 在遍历过程中会对源进行操作，源对象改变后遍历对象同时改变，造成部分线条无法删除
      arrs.forEach(function (ele) {
        // 遍历数组完成线的删除，
        const index = state.flowData.links.findIndex((node) => node.id == ele);
        commit("updateFlowCurrentPath", {
          curPathId: ele,
          curPathIndex: index,
        });
        dispatch("removeFlowPath"); // 移除连线
      });
      state.flowData.selectComponent = ""; // 置空属性菜单
      // state.menuProject.flowData.data.splice(state.menuProject.flowData.data.findIndex(node => node.id==state.menuProject.flowData.currentNodeId.curNodeId),1);//删除节点相关数据
      state.flowData.nodes.splice(state.flowData.currentNodeId.curNodeIndex, 1); // 删除选中节点
      // 置空选中节点
      // commit('updateCurrentNode', {
      //   curPathId: "",
      //   curPathIndex: ""
      // });
      commit("cancelCurrentNode");
    }
  },
  // 删除连线
  removeFlowPath ({ state, commit }) {
    if (state.flowData.currentPath.curPathId != "") {
      var path = state.flowData.links[state.flowData.currentPath.curPathIndex];
      // 恢复线条指向的点的状态
      let list = state.flowData.nodes
        .filter((node) => node.id == path.target)[0]
        .inputs.filter(
          (node) => node.id == path.inputPortId
        )
      if (list.length > 0) list[0].isConnected = false;
      // 移除选中的连线
      state.flowData.links.splice(state.flowData.currentPath.curPathIndex, 1);
      // 选中线条属性置空
      commit("updateFlowCurrentPath", {
        curPathId: "",
        curPathIndex: "",
      });
    }
  },
};

// mutations
const mutations = {
  // 修改流程节点及连线状态为默认状态
  backFlowToDefault (state) {
    var nodes = state.flowData.nodes;
    var links = state.flowData.links;
    nodes.forEach(function (node) {
      node.runStyle = "status-disW";
    });
    links.forEach(function (link) {
      link.runStyle = "";
    });
  },
  updateMenuProjectSelectComponent (state, component) {
    state.flowData.selectComponent = component;
  },
  // 更新组件切换状态，用来销毁右侧组件重构
  updateMenuProjectNodeChange (state) {
    state.flowData.nodeChange = !state.flowData.nodeChange;
  },
  // 清理当前工程数据
  cleanCurFlowData (state) {
    state.flowData.currentNodeItem = {};
    state.flowData.currentProjectDetail = {};
    state.flowData.nodes = [];
    state.flowData.links = [];
  },
  // 更新当前连线节点
  updateFlowCurrentPath (state, payload) {
    state.flowData.currentPath.curPathId = payload.curPathId;
    state.flowData.currentPath.curPathIndex = payload.curPathIndex;
  },
  // 取消当前连线
  cancelFlowCurrentPath () {
    state.flowData.currentPath.curPathId = null;
    state.flowData.currentPath.curPathIndex = -1;
  },
  // 更新可视化编辑移动节点的坐标
  updateNodeXYState (state, nodeId) {
    var node = state.flowData.nodes.filter((node) => node.id == nodeId)[0];
    var position = state.flowData.currentXY;
    node.left = position.left > 0 ? position.left : 0;
    node.top = position.top > 0 ? position.top : 0;
  },
  // 更新当前node节点
  updateCurrentNode (state, payload) {
    state.flowData.currentNodeId.curNodeId = payload.curNodeId;
    state.flowData.currentNodeId.curNodeIndex = payload.curNodeIndex;
  },
  // 取消当前组件
  cancelCurrentNode (state) {
    state.flowData.currentNodeId.curNodeId = "";
    state.flowData.currentNodeId.curNodeIndex = -1;
    state.flowData.currentNodeItem = {};
    state.flowData.selectComponent = null;
  },
  // 清除节点样式
  cancleAllLinkStyle (state) {
    state.flowData.isLinkDrag = false;
    // 清除已被连接的点的可被链接状态
    d3.selectAll(".in .is-connected").classed("is-connectable", false);
    // 清除自身节点的输入可被链接状态
    d3.selectAll(".in .pane-port").classed("is-connectable", false);
  },
  // 添加流程线条
  addFlowLinkNode (state, payload) {
    let targetItem = state.flowData.target;
    console.log(targetItem);
    let pathItem = {
      // 连线信息
      id: payload.outputPortId + "_" + targetItem.targetPortId,
      source: payload.sourceId,
      target: targetItem.targetNodeId,
      inputPortId: targetItem.targetPortId,
      outIndex: targetItem.outIndex,
      outputPortId: payload.outputPortId,
      d: payload.d,
      runStyle: "", // 线条状态pane-link-flow
    };
    state.flowData.links.push(pathItem); // 添加连线
    // 设置箭头指向的点的样式
    state.flowData.nodes
      .filter((node) => node.id == pathItem.target)[0]
      .inputs.filter(
        (node) => node.id == pathItem.inputPortId
      )[0].isConnected = true;
  },
  // 绑定输入源节点数据
  bindResourceNodeOutputData (state, { result_file_path, data }) {
    // inputData 用于编辑数据源、预览
    state.flowData.currentNodeItem.inputData = [data]
    bindResourceData(state.flowData.currentNodeItem, result_file_path);
  }
};
/**
 * 绑定数据源数据
 * @param {*} nodeItem
 * @param {*} data
 */
function bindResourceData (nodeItem, file_path) {
  nodeItem.outputData = {
    result_file_path: file_path,
  }
}
export default {
  state,
  getters,
  actions,
  mutations,
};
